import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { login as apiLogin, type UserDto } from '@/api/auth';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<UserDto | null>(null);
  const token = ref<string>(localStorage.getItem('admin_token') || '');

  const isAuthenticated = computed(() => !!token.value);
  const isAdmin = computed(() => user.value?.systemRole === 'admin');

  async function login(email: string, password: string) {
    // 后端 /api/admin/auth/login 已在服务端校验 admin 身份
    // 非 admin 用户会直接返回 403
    const res = await apiLogin({ email, password });
    token.value = res.accessToken;
    user.value = res.user;
    localStorage.setItem('admin_token', res.accessToken);
  }

  function logout() {
    token.value = '';
    user.value = null;
    localStorage.removeItem('admin_token');
  }

  function restoreUser() {
    // 从 token 中解析 user info（简单实现）
    if (token.value) {
      try {
        const payload = JSON.parse(atob(token.value.split('.')[1]!));
        user.value = {
          id: payload.sub,
          email: '',
          nickname: '',
          systemRole: payload.system_role || 'user',
        };
      } catch {
        logout();
      }
    }
  }

  return { user, token, isAuthenticated, isAdmin, login, logout, restoreUser };
});
